<template>
  <div
    class="sidebar"
    :data-color="activeColor"
    :data-background-color="backgroundColor"
  >
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot></slot>
      <md-list class="nav">
        <slot name="links">
          <sidebar-item
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :link="link"
          >
            <sidebar-item
              v-for="(subLink, index) in link.children"
              :key="subLink.name + index"
              :link="subLink"
            >
            </sidebar-item>
          </sidebar-item>
        </slot>
      </md-list>
    </div>
  </div>
</template>
<script>
export default {
  name: "sidebar",
  props: {
    clickFunc : {
      type :Function,
      default: () => {},
    },
    activeColor: {
      type: String,
      default: "green",
      validator: (value) => {
        let acceptedValues = [
          "",
          "purple",
          "azure",
          "green",
          "orange",
          "danger",
          "rose",
          "diy",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: (value) => {
        let acceptedValues = ["", "black", "white", "red", "diy"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    logo: {
      type: String,
      default: "../img/logo.png",
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
      };
    },
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
.sidebar .nav li:hover > a{
  background: unset !important;
}
.sidebar p,.sidebar span,.sidebar i.md-icon.md-theme-default.md-icon-font{
  color: #FFFFFF !important;
}
.nav-item.active.router-link-active{
  background: #578EFF !important;
}
.nav-item.active.router-link-active a{
  background: unset !important;
}
.sidebar-wrapper li a{
  margin-top: 0 !important;
  padding-top: 11px !important;
  padding-bottom: 11px !important;
}
.sidebar-wrapper li li a{
  margin-top: 0 !important;
  padding: 14px 10px !important;
}
.sidebar .nav li a + div .nav{
  padding-top: 0px !important;
}
</style>
<style scoped>
  .sidebar{
    background: #001529 !important;
  }
</style>